import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");
  const _component_QuestionFilled = _resolveComponent("QuestionFilled");
  const _component_WarningFilled = _resolveComponent("WarningFilled");
  return _openBlock(), _createElementBlock(_Fragment, null, [$props.state == 1 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 0,
    style: {
      "color": "green"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
    _: 1
  })) : _createCommentVNode("", true), $props.state == -1 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 1,
    class: "el-icon-error",
    style: {
      "color": "red"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_CircleCloseFilled)]),
    _: 1
  })) : _createCommentVNode("", true), $props.state == 0 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 2,
    class: "el-icon-question",
    style: {
      "color": "#519eff"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_QuestionFilled)]),
    _: 1
  })) : _createCommentVNode("", true), $props.state == 2 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 3,
    class: "el-icon-warning",
    style: {
      "color": "yellow"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
    _: 1
  })) : _createCommentVNode("", true)], 64);
}